import { FC } from 'react';
import { ButtonProps } from './Button.types';
import { StyledButton, StyledLoading } from './Button.styles';

const Button: FC<ButtonProps> = (props: ButtonProps) => {
  const { children, disabled, id, loading, size } = props;
  return (
    <StyledButton {...props} data-testid={id ?? 'button'}>
      {disabled != null && loading != null && loading ? <StyledLoading size={size} /> : children}
    </StyledButton>
  );
};

export default Button;
